import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageAutoItComponent } from './manage-auto-it/manage-auto-it.component';
import { ManageBugComponent } from './manage-bug/manage-bug.component';
import { ManageJavascriptComponent } from './manage-javascript/manage-javascript.component';
import { ManageLocalizationComponent } from './manage-auto-it/manage-localization/manage-localization.component';
import { ManagePythonScriptComponent } from './manage-python-script/manage-python-script.component';
import { ManageSqlScriptComponent } from './manage-sql-script/manage-sql-script.component';
import { ManageTestDataComponent } from './manage-test-data/manage-test-data.component';
import { AuthCheck } from '../auth/auth.check';


const routes: Routes = [

  {
    path: 'manage-sql-script/:pid', component: ManageSqlScriptComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-javascript/:pid', component: ManageJavascriptComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-bug/:pid', component: ManageBugComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-auto-it/:pid', component: ManageAutoItComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-python-script/:pid', component: ManagePythonScriptComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-localization/:pid', component: ManageLocalizationComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'manage-test-data/:pid', component: ManageTestDataComponent
    ,canActivate:[AuthCheck]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataRoutingModule { }
